import api from "../../../core/api";
import { Page } from "../../../shared/models/models";
import { Offer, OffersQuery } from "../models/customerMyOffersModel";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.tradingBaseUrl };
}

class BuyerOffersApi {
  getOffersAsync(query: OffersQuery): Promise<Page<Offer>> {
    return api.get<Page<Offer>>(
      `/v1/buyer/offers`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }

  getOffer(id: string): Promise<Offer> {
    return api.get<Offer>(`/v1/buyer/offers${id}`, getRequestConfig())
      .then(x => x.data);
  }

  seenOffer(id: string) {
    return api.put<any>(`/v1/buyer/offers/${id}/seen`, null, getRequestConfig());
  }

  declineOffer(id: string) {
    return api.put<any>(`/v1/buyer/offers/${id}/declined`, null, getRequestConfig());
  }

  getDocument(id: string) {
    return api.get<{data: Blob}>(`/v1/buyer/offers/${id}/document`, {...getRequestConfig(), responseType: 'blob' })
  }
}

export default new BuyerOffersApi();